import React, { useEffect, useState } from 'react'
import { AudioVolumeEvent, WarsEvents, AudioControlsPressEvent, DisableUIOverlayEvent } from '@playroomkit/pr-wars/events';
import { getAdjustedVolume } from '@playroomkit/pr-wars/utils';
import ScalableWrapper from '@components/ScalableWrapper';
import View from '@components/View';
import './AudioControls.css';

const AudioControls: React.FC = () => {
  const [showUI, setShowUI] = useState(false);
  const [musicVolume, setMusicVolume] = useState(0.5);
  const [sfxVolume, setSfxVolume] = useState(0.5);

  useEffect(() => {
    const { volume: musicVolume, adjustedVolume: adjustedMusicVolume } = getAdjustedVolume("musicVolume");
    const { volume: sfxVolume, adjustedVolume: adjustedSfxVolume } = getAdjustedVolume("sfxVolume");

    document.dispatchEvent(new AudioVolumeEvent("music", adjustedMusicVolume));
    document.dispatchEvent(new AudioVolumeEvent("sfx", adjustedSfxVolume));

    setMusicVolume(musicVolume);
    setSfxVolume(sfxVolume);
  }, [])


  useEffect(() => {
    const handleButtonClickedEvent = (event: Event) => {
      let e = event as AudioControlsPressEvent;

      if(e.id === 'ui-audio-volume') {
        
        if(showUI) {
          // Intentionally added a delay before opening the audio controls modal  
          // to prevent the mobile touchstart event from immediately closing it.
          setTimeout(() => {
            setShowUI(false);
            document.dispatchEvent(new DisableUIOverlayEvent());
          }, 350);
        } else {
          setTimeout(() => {
            setShowUI(true);
          }, 350);
        }
      }
    }

    document.addEventListener(WarsEvents.AudioControlsPressEvent, handleButtonClickedEvent);

    return () => {
      document.removeEventListener(WarsEvents.AudioControlsPressEvent, handleButtonClickedEvent);
    };
  }, [musicVolume, sfxVolume, showUI]);

  const handleAudioChange = (event: React.ChangeEvent<HTMLInputElement>) => {    
    const volume = parseFloat(event.target.value) / 100;
    const adjustedVolume = Math.pow(volume, 2);
    setMusicVolume(volume);

    document.dispatchEvent(new AudioVolumeEvent('music', adjustedVolume));
    localStorage.setItem('musicVolume', volume.toString());
  };

  // Event handler for sfx slider changes
  const handleSfxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const volume = parseFloat(event.target.value) / 100;
    const adjustedVolume = Math.pow(volume, 2);
    setSfxVolume(volume);

    document.dispatchEvent(new AudioVolumeEvent('sfx', adjustedVolume));
    localStorage.setItem('sfxVolume', volume.toString());
  };

  const handleCloseAudioControls = () => {
    setShowUI(false);
    document.dispatchEvent(new DisableUIOverlayEvent());
  }

  if (!showUI) {
    return <></>
  }

  return (
    <View className='ui-audio-menu-overlay'>
      <View enableEventCapturing className='ui-audio-menu-backdrop' onClick={handleCloseAudioControls} />
      <ScalableWrapper maintainAspectRatioBy="height">
        <View className='ui-audio-menu'>
          <img src="img/UI/TV_Screen.webp" alt="audio-controls" className='ui-audio-screen' />
          <View className='ui-audio-controllers' enableEventCapturing>
            <section>
              <span>Music</span>
              <input
                type="range"
                className="form-range"
                id="ui-audio-slider"
                value={musicVolume * 100}
                onChange={handleAudioChange}
              />
            </section>
            <section>
              <span>SFX</span>
              <input
                type="range"
                className="form-range"
                id="ui-sfx-slider"
                value={sfxVolume * 100}
                onChange={handleSfxChange}
              />
            </section>
          </View>
        </View>
      </ScalableWrapper>
    </View>
  )
};

export default AudioControls;